import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PfdTableSheet from "../../AddEditDuplicatePart/quickView/partPlanQuickView/PfdTableSheet";
import Loader from "../../../components/Control/Loader";
import axios from "axios";

function ViewPFD() {
  const { documentType, id } = useParams();
  // console.log(partId);
  const [data, setData] = useState("");
  useEffect(() => {
    axios
      .get(`/api/getMasterById/${documentType}/${id}`)
      .then((res) => {
        console.log(res.data);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line
  }, []);
  return (
    <div>{data ? <PfdTableSheet data={data} pfdId={id} /> : <Loader />}</div>
  );
}

export default ViewPFD;
